<div style="--swiper-navigation-color: var(--theme-color); --swiper-pagination-color: var(--theme-color)"
  class="swiper hero-swiper">
  <div data-swiper-parallax="-23%"></div>
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let slide of slides">
      <!-- <img class="hero-bg" [src]="slide.background" alt="background" /> -->
      <img [src]="slide.src" alt="slide.alt" class="hero-img" />
    </div>
  </div>

  <app-business-partner-swiper>
  </app-business-partner-swiper>
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
  <div class="swiper-pagination"></div>
</div>


<!-- Why Us -->
<oth-hero [contents]="whyUsTitle"></oth-hero>
<div class="cards-wrapper">
  <app-feature-card *ngFor="let feature of FEATURES" [feature]="feature">
  </app-feature-card>
</div>

<!-- Explore -->
<oth-hero [contents]="exploreTitle"></oth-hero>
<ng-container *ngFor="let productLine of PRODUCT_LINES">
  <!-- <oth-hero [contents]="[{ text: productLine.name, level: 3 }]" [heroClass]="'no-padding'"></oth-hero> -->
  <div class="cards-wrapper">
    <ng-container *ngFor="let product of productLine.products">
      <app-presentation-card [class]="product.color ? product.color : ''"
        [href]="product.redirectToUrl ? product.url : (URLS.product + '/' + product.key)" [imgHeight]="168"
        [imgWidth]="168" [maintenance]="product.url === URLS.maintenance" [secondaryText]="product.description"
        [src]="product.logo" [title]="product.name" class="related-product">
      </app-presentation-card>
    </ng-container>
  </div>
</ng-container>

<!-- And More -->
<!-- <oth-hero [contents]="andMoreTitle"></oth-hero>
<ng-container *ngFor="let productLine of LIBRARIES">
  <oth-hero [contents]="[{ text: productLine.name, level: 3 }]" [heroClass]="'no-padding'"></oth-hero>
  <div class="cards-wrapper">
    <ng-container *ngFor="let product of productLine.products">
      <app-presentation-card [class]="product.color ? product.color : ''"
        [footerText]=getPresentationCardFooter(product.openSource) [href]="product.url" [imgHeight]="150"
        [maintenance]="product.url === URLS.maintenance" [secondaryText]="product.description" [src]="product.logo"
        [title]="product.name" class="related-product">
      </app-presentation-card>
    </ng-container>
  </div>
</ng-container> -->
<!-- <ng-container *ngFor="let productLine of PLUGINS">
  <oth-hero [contents]="[{ text: productLine.name, level: 3 }]" [heroClass]="'no-padding'"></oth-hero>
  <div class="cards-wrapper">
    <ng-container *ngFor="let product of productLine.products">
      <app-presentation-card [class]="product.color ? product.color : ''"
        [footerText]=getPresentationCardFooter(product.openSource) [href]="product.urlAlter" [imgHeight]="150"
        [maintenance]="product.url === URLS.maintenance" [secondaryText]="product.description" [src]="product.logo"
        [title]="product.name" class="related-product">
      </app-presentation-card>
    </ng-container>
  </div>
</ng-container> -->

<!-- Testimonials -->
<oth-hero [contents]="testimonialsTitle"></oth-hero>
<div class="cards-wrapper">
  <app-testimonial-card *ngFor="let testimonial of TESTIMONIALS" [testimonial]="testimonial">
  </app-testimonial-card>
  <oth-button [buttonClasses]="['lighter-contrast-border-color', 'lighter-contrast-font-color', 'transparent-button']"
    [routerLink]="URLS.customers" i18n-text="@@productPage.readMoreStories" text="Read More Stories">
  </oth-button>
</div>

<!-- <app-cookies></app-cookies> -->